import { render, staticRenderFns } from "./DoKoLobby.vue?vue&type=template&id=3959c555&scoped=true&"
import script from "./DoKoLobby.vue?vue&type=script&lang=ts&"
export * from "./DoKoLobby.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoLobby.vue?vue&type=style&index=0&id=3959c555&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3959c555",
  null
  
)

export default component.exports